"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFollowUpDate = exports.getDifferenceBetweenStartAndEndInMin = exports.groupByDays = exports.getMatchingShowingFromExisting = void 0;
var moment_1 = __importDefault(require("moment"));
var moment_range_1 = require("moment-range");
var dates_1 = require("../dates");
/** Cannot use * as Moment due to typescript issue when calling moment functions,
 * use default import and as any in extendMoment
 *
 * https://github.com/rotaready/moment-range/issues/263
 */
var moment = moment_range_1.extendMoment(moment_1.default);
var convertShowingStringsToDates = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate;
    return ({
        startDate: new Date(startDate),
        endDate: new Date(endDate)
    });
};
var getMatchingShowingFromExisting = function (existingShowings, showing, bufferMinutes // increase existingRange by this many minutes so gap between showings still allows match
) {
    var showingDates = convertShowingStringsToDates(showing);
    var match = existingShowings.find(function (existingShowing) {
        var existingShowingDates = convertShowingStringsToDates(existingShowing);
        var startDate = bufferMinutes // don't use moment if not needed, for performance reasons
            ? moment(existingShowingDates.startDate).subtract(bufferMinutes, 'minutes')
            : existingShowingDates.startDate;
        var endDate = bufferMinutes // don't use moment if not needed, for performance reasons
            ? moment(existingShowingDates.endDate).add(bufferMinutes, 'minutes')
            : existingShowingDates.endDate;
        var existingRange = moment.range(startDate, endDate);
        var newRange = moment.range(showingDates.startDate, showingDates.endDate);
        return newRange.overlaps(existingRange);
    });
    return match;
};
exports.getMatchingShowingFromExisting = getMatchingShowingFromExisting;
var groupByDays = function (showings, onlyOnePerDay) {
    var showingIndexedByDay = showings.length > 0
        ? showings.reduce(function (showingsAcc, showing) {
            var showingDateWithoutTime = dates_1.getDateStringWithoutTime(showing.startDate);
            var dateExistsInIndex = Object.keys(showingsAcc).some(function (indexDate) {
                return indexDate === showingDateWithoutTime;
            });
            if (dateExistsInIndex && !onlyOnePerDay) {
                showingsAcc[showingDateWithoutTime].push(showing);
            }
            else if (!dateExistsInIndex) {
                showingsAcc[showingDateWithoutTime] = [showing];
            }
            return showingsAcc;
        }, {})
        : {};
    return showingIndexedByDay;
};
exports.groupByDays = groupByDays;
var getDifferenceBetweenStartAndEndInMin = function (showings) {
    var firstStart = showings[0].startDate;
    var lastEnd = showings[showings.length - 1].endDate;
    return dates_1.getDifferenceInMinutes(lastEnd, firstStart);
};
exports.getDifferenceBetweenStartAndEndInMin = getDifferenceBetweenStartAndEndInMin;
/** follow up date is always 30 minutes before startDate, to allow follow up status scheduler to always update it
 *
 * followUpStatus scheduler is in apartments-api, run every 25 min
 */
var getFollowUpDate = function (reservedShowingStartDate, currentFollowUpDate) {
    var startDateMinus30Min = dates_1.editDate(reservedShowingStartDate, -30, 'minutes').valueOf();
    if (!currentFollowUpDate) {
        return startDateMinus30Min;
    }
    var reservedIsEarlier = startDateMinus30Min < currentFollowUpDate;
    if (reservedIsEarlier) {
        return startDateMinus30Min;
    }
    // return undefined if no need to update followUpDate
    return undefined;
};
exports.getFollowUpDate = getFollowUpDate;
//# sourceMappingURL=showings.js.map